import React from 'react';
import { Redirect, Link } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Pagination from './slider/Pagination';
import Articles from './Articles'
import Hospitals from './Hospitals'





import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/home.css'

import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);



class Home extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      redirectToLogin: false,
      sliderIndex: 0
    }
  }

  slideRenderer = (params) => {
    const { index, key } = params;
    switch (mod(index, 4)) {
      case 0:
        return (
          <a key={key} href='https://www.google.com/maps/d/viewer?mid=1zLU5JP0R21zsBK7kLOFhjk9Rujl2tw3s' target='blank'>
            <div  class='home-slider-slide'>
              <img src='./images/webnHospitals.svg' />
            </div>
          </a>
        );

      case 1:
        return (
          <a href='#prvsec' key={key}>

          <div  class='home-slider-slide'>
            <img src='./images/webnPapers.svg' />

            </div>
            </a>
        );

      case 2:
        return (
          <a href='#articlesec' key={key}>

          <div  class='home-slider-slide'>
            <img src='./images/webnPrevention.svg' />

            </div>
            </a>
        );
      case 3:
        return (
          <Link to='/test' key={key}>
          <div  class='home-slider-slide'>
            <img src='./images/webnOnlineTest.svg' />

            </div>
          </Link>
        );

      default:
        return null;
    }
  }


  handleChangeIndex = index => {
    this.setState({ sliderIndex: index })
  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/login' />
    }
    return (
      <React.Fragment>
        <Header title="سامانه تشخیص کرونای طبینجا" showBackButton={false}></Header>
        <div class="home-root">
          <div class='slider-container'>
            <VirtualizeSwipeableViews slideRenderer={this.slideRenderer} className='home-slider-root' index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} />
            <Pagination dots={4} index={this.state.sliderIndex} onChangeIndex={this.handleChangeIndex} />
          </div>
          <div class='test-section'>
            <h2>فکر میکنید به کرونا مبتلا شدید؟</h2>
            <span>انجام تست زیر به شما کمک میکند تا تصمیم بهتری بگیرید</span>
            <Link to='/test' className='button' style={{ width: '80%' }}>شروع تست کرونا</Link>
          </div>
          <div style={{ backgroundColor: '#ddd' }}>
            <div class='prevention-section' id='prvsec'>
              <div class='prevention-art'>
                <img src='/images/art.svg' />
              </div>
              <Link to='/article/9908b97c57ecb8bb'>
                <div class='prevention-post card'>
                  <img src='https://www.tebinja.com/img/uploads/blog/15470.jpeg' />
                  <div class='prevention-post-title'>
                    پیشگیری از ویروس کرونا
                </div>
                  <div class='prevention-post-desc'>
                    کرونا ویروس طیف وسیعی از علائم‌ بالینی را ایجاد میکند در این مقاله به بررسی ویروس کرونا خطرناک تر اس...
                </div>
                </div>
              </Link>
              <Link to='/article/1ea463859482b8ab'>
                <div class='prevention-post card'>
                  <img src='https://www.tebinja.com/img/uploads/blog/4547.jpeg' />
                  <div class='prevention-post-title'>
                    بهترین راه مقابله کردن با ویروس کرونا
                </div>
                  <div class='prevention-post-desc'>
                    بهترین راه مقابله کردن با این بیماری، ایزوله کردن فرد مبتلا و پیشگیری از بیماری هست در این مقاله به ...
                </div>
                </div>
              </Link>
              <Link to='/article/33a5c303e1caf9e6'>
                <div class='prevention-post card'>
                  <img src='https://www.tebinja.com/img/uploads/blog/412439.jpeg' />
                  <div class='prevention-post-title'>
                    هرآنچه باید در مورد کرونا ویروس و راههای مقابله با آن بدانیم
                </div>
                  <div class='prevention-post-desc'>
                    در حقیقت کرونا ویروس ها خانواده بزرگی از ویروس ها هستند در این مقاله به بررسی هرآنچه باید در مورد کر...
                </div>
                </div>
              </Link>

            </div>
          </div>
          <div class='article-section' id='articlesec'>
            <Articles></Articles>
          </div>
          {/* <div class='hospital-section'>
            <Hospitals></Hospitals>
          </div> */}
        </div>
      </React.Fragment>
    )
  }

}

export default Home